import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-request-approval-for-admin.module.scss";
import { useOtaRequestApprovalForAdmin } from "./use-ota-request-approval-for-admin";
import type { InstallAndActionBlock } from "@src/cloud-connect/ota-update/constants";
import type { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface OTARequestApprovalForAdminProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
  setInstallAndActionBlock: React.Dispatch<
    React.SetStateAction<InstallAndActionBlock | null>
  >;
}

const cssClassName = "ota-request-approval-for-admin";

export default function OTARequestApprovalForAdmin({
  activeInstallationData,
  setInstallAndActionBlock,
}: OTARequestApprovalForAdminProps) {
  const {
    texts,
    descriptionText,
    showContent,
    handleReviewRequestAndApprove,
    handleCancelRequest,
    isCancelRequestLoading,
  } = useOtaRequestApprovalForAdmin({
    activeInstallationData,
    setInstallAndActionBlock,
  });

  if (!showContent) return null;

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefix}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titleSuffix}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {descriptionText}
          </span>
        </div>
      </div>

      <div className={styles[`${cssClassName}__actions`]}>
        <OTAInstallActionButton
          text={texts.reviewAndApproveButtonText}
          variant="primary"
          fun={handleReviewRequestAndApprove}
        />
        <OTAInstallActionButton
          text={texts.cancelRequestButtonText}
          variant="secondary"
          fun={handleCancelRequest}
          disabled={isCancelRequestLoading}
        />
      </div>
    </div>
  );
}
